/**
 * Games Info Game Model
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require ('underscore');
    var BaseModel = require('common/base.model');
    var config = require('config');
    var device = require('util/device.util');

    module.exports = BaseModel.extend({

        idAttribute: 'gameCode',

        _getGameConfiguration: function(gameType, gameName) {
            return _.findWhere(
                config.get('gamesConfiguration'),
                {bingoGameType: gameType, gameCode: gameName}
            );
        },

        subscribe: function() {
            this.once('change', this._setUpTimers.bind(this));
        },

        parse: function(item) {
            var out = {};
            var formatKeyNaming = function(str) {
                return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
                    return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
                }).replace(/\s+/g, '');
            };

            var itemConfiguration = this._getGameConfiguration(item.gameType, item.gameName);

            if (itemConfiguration) {
                out = {
                    imageURL: this._getImageUrl(itemConfiguration)
                };
            }

            _.keys(item).forEach(function(key) {
                out[formatKeyNaming(key)] = item[key];
            });

            return _.extend({}, itemConfiguration, out);
        },

        _getImageUrl: function(conf) {
            var url = device.formFactor === 'desktop' ? 'imageURLs' : 'mobileImageURLs';
            return conf[url] && conf[url].c1x1;
        },

        _getTimeLeft: function() {
            var drawTime = this.get('drawTime');

            if (!drawTime) {
                return false;
            }

            return (new Date(drawTime.replace(' ', 'T') + 'Z')).getTime() - (new Date()).getTime();
        },

        _setUpTimers: function() {
            var timeLeft = this._getTimeLeft();

            if (!timeLeft || Number(timeLeft) < 0) {
                return;
            }

            // set up interval for display time value
            this.updateInterval = setInterval(function() {
                this.set('timeLeftInSeconds', this._getTimeLeft());
            }.bind(this), 1000);

            // Set time in first time
            this.set('timeLeftInSeconds', timeLeft);

            // set up remove timeout
            this.removeTimer = setTimeout(this.destroy.bind(this), timeLeft);
        },

        destroy: function() {
            clearTimeout(this.removeTimer);
            clearInterval(this.updateInterval);

            this.stopListening();
            this.trigger('destroy', this, this.collection, window.scrollY);
        }

    });
});
